const languageTabSwitcher = () => {
    if (document.querySelector('.ume-language-tab-wrapper')) {
        const wrappers = document.querySelectorAll('.ume-language-tab-wrapper');
        wrappers.forEach(w => {
            const switcherHolder = w.querySelector('.ume-language-wrapper-switcher-holder');
            const tabs = w.querySelectorAll('.ume-language-tab');
            if (tabs !== null && tabs.length > 0) {
                tabs.forEach(t => {
                    let imageLink = t.getAttribute('data-flag-url');
                    let language = t.getAttribute('data-language-label');
                    let newControl = document.createElement('button');
                    let newInner = document.createElement('img');
                    newInner.src = imageLink;
                    newInner.alt = '';
                    newControl.setAttribute('title', language);
                    newControl.classList.add('ume-language-wrapper-switcher-button')
                    newControl.classList.add('btn')
                    newControl.classList.add('btn-link')
                    newControl.setAttribute('data-target', `${t.id}`)
                    newControl.setAttribute('aria-controls', `${t.id}`)
                    newControl.setAttribute('aria-selected', false)
                    if (t.classList.contains('ume-language-tab-active')) {
                        newControl.classList.add('d-none');
                        newControl.setAttribute('aria-selected', true)
                    }
                    newControl.appendChild(newInner);
                    switcherHolder.appendChild(newControl);
                })
                w.addEventListener('click', ev => {
                    if (!ev.target.closest('.ume-language-wrapper-switcher-button')) return;
                    let button = ev.target.closest('.ume-language-wrapper-switcher-button');
                    let buttonTarget = button.getAttribute('data-target');
                    let target = document.getElementById(buttonTarget);
                    let activeButton = switcherHolder.querySelector('.ume-language-wrapper-switcher-button.d-none')
                    tabs.forEach(t => {
                        t.classList.add('d-none');
                        t.classList.remove('ume-language-tab-active')
                        t.setAttribute('aria-hidden', true);
                    })
                    target.classList.remove('d-none');
                    target.classList.add('ume-language-tab-active');
                    target.setAttribute('aria-hidden', false);
                    button.classList.add('d-none');
                    button.setAttribute('aria-selected', true)
                    if (activeButton !== null) {
                        activeButton.classList.remove('d-none');
                        activeButton.setAttribute('aria-selected', false)
                    }


                })
            }
        })
    }
}
export default languageTabSwitcher;